export const getDecimalLength = (value: number): number => Math.floor(value / 100).toString().length;